import { Contact } from '../../models/contact';
import { BaseEntity } from '../../models/base-entity';
import { ThreatType } from '../../models/threat-type';
import { Threat } from '../../models/threat';
import { EntityType } from '../../models/entity-type';
import { RiskTemplate } from '../../models/risk-template';
import { AssessmentTarget } from '../../models/assessment-target';
import { RiskFormulaType } from '../../models/risk-formula-type';
import { RiskEquationPart, RiskFormula } from '../../models/risk-formula';
import { AssessmentStatus } from '../../models/assessment-status';
import { RiskFactorType } from '../../models/risk-factor-type';
import { QuestionType } from '../../models/question-type';
import { QuestionAnswer } from '../../models/question-answer';
import { AssessmentDistributionRisk } from '../../models/assessment-distribution-risk';
import { AssessmentMemberData } from '../../models/assessment-member-data';
import { Assessment } from '../../models/assessment';
import { RiskFormulaStatus } from '../../models/risk-formula-status';
import { RiskFactor } from '../../models/risk-factor';
import { EquationPartTypes } from '../../models/risk-equation-part-type';
import { QuestionFactorType } from '../../models/question-factor-type';
import { Question } from '../../models/question';

export const riskFormulaEquation: RiskEquationPart[] = [
  {
    order: 0,
    label: 'IMPACTFORMULA',
    type: EquationPartTypes.factor,
    isEdit: false,
    factorId: null
  },
  {
    order: 1,
    label: '*',
    type: EquationPartTypes.operator,
    isEdit: false,
    factorId: null
  },
  {
    order: 2,
    label: 'PROBABILITYFORMULA',
    type: EquationPartTypes.factor,
    isEdit: false,
    factorId: null
  }
];

export const mockedData = {
  currentLoggedInUser: {
    id: '1',
    firstName: 'Alfred',
    middleInitials: '',
    lastName: 'Ramses',
    isNotifiable: true,
    name: 'Alfred Ramses',
    displayName: 'Alfred Ramses',
    role: 'USER'
  } as Contact,
  threatTypes: [
    {
      id: '1',
      name: 'Risk Template 01',
      numericValue: 0,
      threats: new Array<BaseEntity>(),
      events: new Array<BaseEntity>(),
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    },
    {
      id: '2',
      name: 'Threat Type 02',
      numericValue: 1,
      threats: new Array<BaseEntity>(),
      events: new Array<BaseEntity>(),
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    },
    {
      id: '3',
      name: 'Threat Type 03',
      numericValue: 3,
      threats: new Array<BaseEntity>(),
      events: new Array<BaseEntity>(),
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    },
    {
      id: '4',
      name: 'Threat Type 04',
      numericValue: 2,
      threats: new Array<BaseEntity>(),
      events: new Array<BaseEntity>(),
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    }
  ] as Array<ThreatType>,

  riskTemplates: [
    {
      id: '1',
      name: 'Risk Template 01',
      description: 'Risk Template 01',
      threats: [
        {
          id: '1',
          name: 'threat 1',
          description: '',
          riskTemplate: {
            id: '1',
            name: 'Risk Template 01',
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          threatType: {
            id: '1',
            name: 'Terrorism',
            numericValue: 0,
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          questions: [
            {
              type: 'YES_NO',
              evenWeight: false,
              threatId: '1',
              weight: 25,
              increasingAnswer: QuestionAnswer.yes,
              position: 0,
              isDefaultQuestion: true,
              requireCommentForNA: false,
              factorType: QuestionFactorType.impact,
              id: '2',
              name: 'do you have a bomb threat procedure 1 ?'
            },
            {
              type: 'YES_NO',
              evenWeight: false,
              threatId: '1',
              weight: 25,
              increasingAnswer: QuestionAnswer.yes,
              position: 0,
              isDefaultQuestion: true,
              requireCommentForNA: false,
              factorType: QuestionFactorType.impact,
              id: '2',
              name: 'do you have a bomb threat procedure 2?'
            }
          ],
          isPlanRequired: false,
          lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
          lastUpdatedBy: 'Lastname, Firstname'
        } as Threat,
        {
          id: '3',
          name: 'threat 2',
          description: '',
          riskTemplate: {
            id: '1',
            name: 'Risk Template 01',
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          threatType: {
            id: '2',
            name: 'Facilities',
            numericValue: 0,
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          questions: [
            {
              type: 'YES_NO',
              evenWeight: false,
              threatId: '3',
              weight: 25,
              increasingAnswer: QuestionAnswer.yes,
              position: 0,
              isDefaultQuestion: true,
              requireCommentForNA: false,
              factorType: QuestionFactorType.impact,
              id: '3',
              name: 'do you have a bomb threat procedure 3?'
            },
            {
              type: 'YES_NO',
              evenWeight: false,
              threatId: '3',
              weight: 25,
              increasingAnswer: QuestionAnswer.yes,
              position: 0,
              isDefaultQuestion: true,
              requireCommentForNA: false,
              factorType: QuestionFactorType.impact,
              id: '2',
              name: 'do you have a bomb threat procedure 4?'
            }
          ],
          isPlanRequired: false,
          lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
          lastUpdatedBy: 'Lastname, Firstname'
        } as Threat,
        {
          id: '4',
          name: 'Threat 04',
          description: '',
          riskTemplate: {
            id: '1',
            name: 'Risk Template 01',
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          threatType: {
            id: '3',
            name: '1-Operational',
            numericValue: 0,
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          questions: [
            {
              type: 'YES_NO',
              evenWeight: false,
              threatId: '4',
              weight: 25,
              increasingAnswer: QuestionAnswer.yes,
              position: 0,
              isDefaultQuestion: true,
              requireCommentForNA: false,
              factorType: QuestionFactorType.impact,
              id: '2',
              name: 'do you have a bomb threat procedure 5?'
            },
            {
              type: 'YES_NO',
              evenWeight: false,
              threatId: '4',
              weight: 25,
              increasingAnswer: QuestionAnswer.yes,
              position: 0,
              isDefaultQuestion: true,
              requireCommentForNA: false,
              factorType: QuestionFactorType.impact,
              id: '2',
              name: 'do you have a bomb threat procedure 6?'
            }
          ],
          isPlanRequired: false,
          lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
          lastUpdatedBy: 'Lastname, Firstname'
        } as Threat
      ],
      targetEntityType: EntityType.vendor,
      templateType: 'OVER_ALL_RISK',
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    } as RiskTemplate,
    {
      id: '2',
      name: 'Risk Template 02',
      description: 'Risk Template 02',
      threats: [
        {
          id: '2',
          name: 'Threat 02',
          description: '',
          riskTemplate: {
            id: '2',
            name: 'Risk Template 02',
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          threatType: {
            id: '1',
            name: 'Threat Type 01',
            numericValue: 0,
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          questions: [],
          isPlanRequired: false,
          lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
          lastUpdatedBy: 'Lastname, Firstname'
        } as Threat,
        {
          id: '5',
          name: 'Threat 05',
          description: '',
          riskTemplate: {
            id: '2',
            name: 'Risk Template 02',
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          threatType: {
            id: '2',
            name: 'Threat Type 02',
            numericValue: 0,
            lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
            lastUpdatedBy: 'Lastname, Firstname'
          },
          questions: [],
          isPlanRequired: false,
          lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
          lastUpdatedBy: 'Lastname, Firstname'
        } as Threat
      ],
      targetEntityType: EntityType.site,
      templateType: 'OVER_ALL_RISK',
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    } as RiskTemplate
  ] as Array<RiskTemplate>,

  assessmentTargets: [
    {
      id: '1',
      name: 'Piedmont',
      description: '',
      contacts: [
        {
          id: '1',
          firstName: 'Tony',
          middleInitials: '',
          lastName: 'Starks',
          isNotifiable: true,
          description: ''
        } as Contact,
        {
          id: '2',
          firstName: 'Mickey',
          middleInitials: '',
          lastName: 'Mouse',
          isNotifiable: true,
          description: ''
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.site
    } as AssessmentTarget,
    {
      id: '2',
      name: 'Basin',
      description: '',
      contacts: [
        {
          id: '1',
          firstName: 'Tony',
          middleInitials: '',
          lastName: 'Starks',
          isNotifiable: true,
          description: ''
        } as Contact,
        {
          id: '2',
          firstName: 'Mickey',
          middleInitials: '',
          lastName: 'Mouse',
          isNotifiable: true,
          description: ''
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.site
    } as AssessmentTarget,
    {
      id: '1',
      name: 'Acme',
      contacts: [
        {
          id: '1',
          firstName: 'Tony',
          middleInitials: '',
          lastName: 'Starks',
          isNotifiable: true,
          description: ''
        } as Contact,
        {
          id: '2',
          firstName: 'Mickey',
          middleInitials: '',
          lastName: 'Mouse',
          isNotifiable: true,
          description: ''
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.vendor,
    } as AssessmentTarget,
    {
      id: '2',
      name: 'Tyco',
      contacts: [
        {
          id: '3',
          firstName: 'Johnny',
          middleInitials: '',
          lastName: 'Rockets',
          isNotifiable: true,
          description: ''
        } as Contact,
        {
          id: '4',
          firstName: 'Donald',
          middleInitials: '',
          lastName: 'Duck',
          isNotifiable: true,
          description: ''
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.vendor,
    } as AssessmentTarget,
    {
      id: '1',
      name: 'Accounting',
      contacts: [
        {
          id: '5',
          firstName: 'Ralph',
          middleInitials: '',
          lastName: 'Lauren',
          isNotifiable: true,
          description: ''
        } as Contact,
        {
          id: '6',
          firstName: 'Marty',
          middleInitials: '',
          lastName: 'McFly',
          isNotifiable: true,
          description: ''
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.department,
    } as AssessmentTarget,
    {
      id: '2',
      name: 'Finance',
      contacts: [
        {
          id: '7',
          firstName: 'James',
          middleInitials: '',
          lastName: 'Bond',
          isNotifiable: true,
          description: ''
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.department
    } as AssessmentTarget,
    {
      id: '1',
      name: 'Vacuuming',
      contacts: [
        {
          id: '8',
          firstName: 'Mister',
          middleInitials: '',
          lastName: 'Clean',
          isNotifiable: true,
          description: ''
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.productAndService
    } as AssessmentTarget,
    {
      id: '1',
      name: 'Laptop',
      contacts: [
        {
          id: '8',
          firstName: 'Mister',
          middleInitials: '',
          lastName: 'Clean',
          isNotifiable: true,
          description: '',
          employeeId: '008'
        } as Contact
      ] as Array<Contact>,
      entityType: EntityType.resource
    } as AssessmentTarget
  ] as Array<AssessmentTarget>,

  riskFormulas: [
    {
      id: '1',
      name: 'Default Formula',
      equation: riskFormulaEquation,
      formulaType: RiskFormulaType.multiPart,
      rounding: false,
      defaultFormula: true,
      formulas: [
        {
          id: '2',
          name: '',
          equation: [
            {
              order: 0,
              label: '(',
              type: EquationPartTypes.parenthesise,
              isEdit: false,
              factorId: null
            },
            {
              order: 1,
              label: 'Impact',
              type: EquationPartTypes.factor,
              isEdit: false,
              factorId: 1
            },
            {
              order: 2,
              label: ')',
              type: EquationPartTypes.parenthesise,
              isEdit: false,
              factorId: null
            }
          ],
          formulaType: RiskFormulaType.impact,
          rounding: 1,
          defaultFormula: false
        },
        {
          id: '3',
          name: '',
          equation: [
            {
              order: 0,
              label: 'Probability',
              type: EquationPartTypes.factor,
              isEdit: false,
              factorId: 2
            }
          ],
          formulaType: RiskFormulaType.probability,
          rounding: false,
          defaultFormula: false
        }
      ],
      entityType: null,
      lastUpdatedBy: 'Jhon Doe',
      lastUpdateDate: new Date('2021-12-21T18:39:23.727Z'),
      status: RiskFormulaStatus.active
    } as RiskFormula,
    {
      id: '2',
      name: '',
      equation: [
        {
          order: 0,
          label: '2',
          type: EquationPartTypes.number,
          isEdit: false,
          factorId: null
        },
        {
          order: 1,
          label: '+',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 2,
          label: 'Impact',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 1
        }
      ],
      formulaType: RiskFormulaType.impact,
      rounding: false,
      defaultFormula: false
    } as RiskFormula,
    {
      id: '3',
      name: '',
      equation: [
        {
          order: 0,
          label: '2',
          type: EquationPartTypes.number,
          isEdit: false,
          factorId: null
        },
        {
          order: 1,
          label: '+',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 2,
          label: 'Probability',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 2
        }
      ],
      formulaType: RiskFormulaType.probability,
      rounding: false,
      defaultFormula: false
    } as RiskFormula,
    {
      id: '4',
      name: 'Simple Formula 01',
      equation: [
        {
          order: 0,
          label: '5',
          type: EquationPartTypes.number,
          isEdit: false,
          factorId: null
        },
        {
          order: 1,
          label: '*',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 2,
          label: 'Magnitude',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 3
        }
      ],
      formulaType: RiskFormulaType.simple,
      rounding: false,
      defaultFormula: false,
      entityType: EntityType.department,
      status: RiskFormulaStatus.draft
    } as RiskFormula,
    {
      id: '5',
      name: 'Simple Formula 02',
      equation: [
        {
          order: 0,
          label: 'Impact',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 1
        },
        {
          order: 1,
          label: '*',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 2,
          label: 'Probability',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 2
        },
        {
          order: 3,
          label: '+',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 4,
          label: 'Magnitude',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 3
        }
      ],
      formulaType: RiskFormulaType.simple,
      rounding: false,
      defaultFormula: false,
      entityType: EntityType.resource,
      lastUpdatedBy: 'Jhon Doe',
      lastUpdateDate: new Date('2021-12-21T18:39:23.727Z'),
      status: RiskFormulaStatus.active
    } as RiskFormula,
    {
      id: '6',
      name: 'Additional Advanced Formula',
      equation: riskFormulaEquation,
      formulaType: RiskFormulaType.multiPart,
      rounding: false,
      defaultFormula: false,
      formulas: [
        {
          id: '7',
          name: '',
          equation: [
            {
              order: 0,
              label: 'Impact',
              type: EquationPartTypes.factor,
              isEdit: false,
              factorId: 1
            },
            {
              order: 1,
              label: '*',
              type: EquationPartTypes.operator,
              isEdit: false,
              factorId: null
            },
            {
              order: 2,
              label: 'Magnitude',
              type: EquationPartTypes.factor,
              isEdit: false,
              factorId: 3
            },
            {
              order: 3,
              label: '+',
              type: EquationPartTypes.operator,
              isEdit: false,
              factorId: null
            },
            {
              order: 4,
              label: '1',
              type: EquationPartTypes.number,
              isEdit: false,
              factorId: null
            }
          ],
          formulaType: RiskFormulaType.impact,
          rounding: false,
          defaultFormula: false
        },
        {
          id: '8',
          name: '',
          equation: [
            {
              order: 0,
              label: 'Probability',
              type: EquationPartTypes.factor,
              isEdit: false,
              factorId: 1
            },
            {
              order: 1,
              label: '+',
              type: EquationPartTypes.operator,
              isEdit: false,
              factorId: null
            },
            {
              order: 2,
              label: '2',
              type: EquationPartTypes.number,
              isEdit: false,
              factorId: null
            }
          ],
          formulaType: RiskFormulaType.probability,
          rounding: 1,
          defaultFormula: false
        }
      ],
      entityType: EntityType.vendor,
      lastUpdatedBy: 'BB. C',
      lastUpdateDate: new Date('2021-12-21T18:39:23.727Z'),
      status: RiskFormulaStatus.draft
    } as RiskFormula,
    {
      id: '7',
      name: '',
      equation: [
        {
          order: 0,
          label: 'Impact',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 1
        },
        {
          order: 1,
          label: '+',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 2,
          label: 'Magnitude',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 3
        },
        {
          order: 3,
          label: '+',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 4,
          label: '1',
          type: EquationPartTypes.number,
          isEdit: false,
          factorId: 3
        }
      ],
      formulaType: RiskFormulaType.impact,
      rounding: false,
      defaultFormula: false
    } as RiskFormula,
    {
      id: '8',
      name: '',
      equation: [
        {
          order: 0,
          label: 'Probability',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 2
        },
        {
          order: 1,
          label: '+',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 2,
          label: '2',
          type: EquationPartTypes.number,
          isEdit: false,
          factorId: null
        }
      ],
      formulaType: RiskFormulaType.probability,
      rounding: false,
      defaultFormula: false
    } as RiskFormula,
    {
      id: '9',
      name: 'Earthquake Formula',
      equation: [
        {
          order: 0,
          label: 'Impact',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 1
        },
        {
          order: 1,
          label: '*',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 2,
          label: 'Probability',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 2
        },
        {
          order: 3,
          label: '*',
          type: EquationPartTypes.operator,
          isEdit: false,
          factorId: null
        },
        {
          order: 4,
          label: 'Awareness',
          type: EquationPartTypes.factor,
          isEdit: false,
          factorId: 5
        }
      ],
      formulaType: RiskFormulaType.simple,
      rounding: 1,
      defaultFormula: false,
      entityType: EntityType.site,
      lastUpdateDate: new Date('2022-1-16T18:39:23.727Z'),
      status: RiskFormulaStatus.draft,
      factors: [
        {
          id: '1',
          name: 'Impact',
          description: 'Impact',
          type: RiskFactorType.impact,
          ranks: [
            {
              id: '51',
              name: 'Extremely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '52',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '53',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '54',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '55',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '2',
          name: 'Probability',
          description: 'Probability',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '61',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '62',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '63',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '64',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '65',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '3',
          name: 'Awareness',
          description: 'Awareness',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '71',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '72',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '73',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '74',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '75',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        }
      ],
      bands: [
        {
          id: '1',
          name: 'Low',
          color: 'yellow',
          numericValue: 1,
          rounding: true
        },
        {
          id: '2',
          name: 'Medium',
          color: 'orange',
          numericValue: 2,
          rounding: true
        },
        {
          id: '3',
          name: 'High',
          color: 'red',
          numericValue: 3,
          rounding: true
        }
      ]
    }
  ],

  assessments: [
    {
      id: '1',
      name: 'Site Survey on February 22, 2022',
      status: AssessmentStatus.incomplete,
      percentInt: 0,
      createdDate: new Date('2022-02-22T22:22:22.222Z'),
      dueDate: new Date('2022-02-24T00:00:00.000Z'),
      comments: [
        {
          id: '5',
          comments: 'If I could only fill out one survey, this would be it.',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true,
            description: ''
          },
          owner: {
            id: '2',
            name: 'Vendor Survey on February 23'
          },
          deletedPersonnelRecord: null
        },
        {
          id: '6',
          comments: 'Check out the wheels on that 4x4!',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true,
            description: ''
          },
          owner: {
            id: '2',
            name: 'Vendor Survey on February 23'
          },
          deletedPersonnelRecord: null
        }
      ],
      parent: {
        id: '1',
        name: 'Piedmont',
        entityType: EntityType.site
      },
      factors: [
        {
          id: '1',
          name: 'Impact',
          description: 'Impact',
          type: RiskFactorType.impact,
          ranks: [
            {
              id: '51',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '52',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '53',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '54',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '55',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '2',
          name: 'Probability',
          description: 'Probability',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '61',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '62',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '63',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '64',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '65',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '3',
          name: 'Awareness',
          description: 'Awareness',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '71',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '72',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '73',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '74',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '75',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        }
      ],
      riskBands: [
        {
          id: '1',
          name: 'Low',
          color: 'yellow',
          numericValue: 1,
          rounding: true
        },
        {
          id: '2',
          name: 'Medium',
          color: 'orange',
          numericValue: 2,
          rounding: true
        },
        {
          id: '3',
          name: 'High',
          color: 'red',
          numericValue: 3,
          rounding: true
        }
      ],
      riskFormula: {
        id: '9',
        name: 'Earthquake Formula',
        equation: [], // 'impact * probability * awareness',
        formulaType: RiskFormulaType.simple,
        rounding: false,
        defaultFormula: false,
        formulas: []
      }
    },
    {
      id: '2',
      name: 'Vendor Survey on February 23',
      status: AssessmentStatus.incomplete,
      percentInt: 0,
      createdDate: new Date('2022-02-23T22:22:22.222Z'),
      dueDate: new Date('2022-02-26T00:00:00.000Z'),
      comments: [
        {
          id: '3',
          comments: 'This survey took a little bit more time',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true,
            description: ''
          },
          owner: {
            id: '2',
            name: 'Vendor Survey on February 23'
          },
          deletedPersonnelRecord: null
        },
        {
          id: '4',
          comments: 'But it was still really fun to do',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true,
            description: ''
          },
          owner: {
            id: '2',
            name: 'Vendor Survey on February 23'
          },
          deletedPersonnelRecord: null
        }
      ],
      parent: {
        id: '1',
        name: 'Acme',
        entityType: EntityType.vendor
      },
      factors: [
        {
          id: '1',
          name: 'Impact',
          description: 'Impact',
          type: RiskFactorType.impact,
          ranks: [
            {
              id: '51',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '52',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '53',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '54',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '55',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '2',
          name: 'Probability',
          description: 'Probability',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '61',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '62',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '63',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '64',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '65',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '3',
          name: 'Awareness',
          description: 'Awareness',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '71',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '72',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '73',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '74',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '75',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        }
      ],
      riskBands: [
        {
          id: '1',
          name: 'Low',
          color: 'yellow',
          numericValue: 1,
          rounding: true
        },
        {
          id: '2',
          name: 'Medium',
          color: 'orange',
          numericValue: 2,
          rounding: true
        },
        {
          id: '3',
          name: 'High',
          color: 'red',
          numericValue: 3,
          rounding: true
        }
      ],
      riskFormula: {
        id: '1',
        name: 'Formula 01',
        equation: riskFormulaEquation,
        formulaType: RiskFormulaType.multiPart,
        rounding: false,
        defaultFormula: true,
        formulas: []
      }
    },
    {
      id: '3',
      name: 'Product and Service Survey on February 21',
      status: AssessmentStatus.incomplete,
      percentInt: 0,
      createdDate: new Date('2022-02-21T22:22:22.222Z'),
      dueDate: new Date('2022-02-24T00:00:00.000Z'),
      comments: [
        {
          id: '1',
          comments: 'This survey was completed quickly',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true
          },
          owner: {
            id: '3',
            name: 'Product and Service Survey on February 21'
          },
          deletedPersonnelRecord: null
        },
        {
          id: '2',
          comments: 'For reals, it was done really quick',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true
          },
          owner: {
            id: '3',
            name: 'Product and Service Survey on February 21'
          },
          deletedPersonnelRecord: null
        }
      ],
      parent: {
        id: '1',
        name: 'Vacumming',
        entityType: EntityType.productAndService
      },
      factors: [
        {
          id: '1',
          name: 'Impact',
          description: 'Impact',
          type: RiskFactorType.impact,
          ranks: [
            {
              id: '51',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '52',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '53',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '54',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '55',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '2',
          name: 'Probability',
          description: 'Probability',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '61',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '62',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '63',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '64',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '65',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '3',
          name: 'Awareness',
          description: 'Awareness',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '71',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '72',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '73',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '74',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '75',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        }
      ],
      riskBands: [
        {
          id: '1',
          name: 'Low',
          color: 'yellow',
          numericValue: 1,
          rounding: true
        },
        {
          id: '2',
          name: 'Medium',
          color: 'orange',
          numericValue: 2,
          rounding: true
        },
        {
          id: '3',
          name: 'High',
          color: 'red',
          numericValue: 3,
          rounding: true
        }
      ],
      riskFormula: {
        id: '1',
        name: 'Formula 01',
        equation: riskFormulaEquation,
        formulaType: RiskFormulaType.multiPart,
        rounding: false,
        defaultFormula: true,
        formulas: []
      }
    },
    {
      id: '4',
      name: 'Vendors on February 25',
      status: AssessmentStatus.incomplete,
      percentInt: 0,
      createdDate: new Date('2022-02-21T22:22:22.222Z'),
      dueDate: new Date('2022-02-25T00:00:00.000Z'),
      comments: [
        {
          id: '1',
          comments: 'This survey was completed quickly',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true
          },
          owner: {
            id: '3',
            name: 'Product and Service Survey on February 21'
          },
          deletedPersonnelRecord: null
        },
        {
          id: '2',
          comments: 'For reals, it was done really quick',
          contact: {
            id: '5',
            firstName: 'Ralph',
            middleInitials: '',
            lastName: 'Lauren',
            isNotifiable: true
          },
          owner: {
            id: '3',
            name: 'Product and Service Survey on February 21'
          },
          deletedPersonnelRecord: null
        }
      ],
      parent: {
        id: '1',
        name: 'Vacumming',
        entityType: EntityType.productAndService
      },
      factors: [
        {
          id: '1',
          name: 'Impact',
          description: 'Impact',
          type: RiskFactorType.impact,
          ranks: [
            {
              id: '51',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '52',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '53',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '54',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '55',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '2',
          name: 'Probability',
          description: 'Probability',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '61',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '62',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '63',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '64',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '65',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        },
        {
          id: '3',
          name: 'Awareness',
          description: 'Awareness',
          type: RiskFactorType.probability,
          ranks: [
            {
              id: '71',
              name: 'Extermely Low',
              numericValue: 1,
              description: 'Low'
            },
            {
              id: '72',
              name: 'Low',
              numericValue: 2,
              description: 'Low'
            },
            {
              id: '73',
              name: 'Medium',
              numericValue: 3,
              description: 'Medium'
            },
            {
              id: '74',
              name: 'High',
              numericValue: 4,
              description: 'High'
            },
            {
              id: '75',
              name: 'Extremely High',
              numericValue: 5,
              description: 'Extremely High'
            }
          ]
        }
      ],
      riskBands: [
        {
          id: '1',
          name: 'Low',
          color: 'yellow',
          numericValue: 1,
          rounding: true
        },
        {
          id: '2',
          name: 'Medium',
          color: 'orange',
          numericValue: 2,
          rounding: true
        },
        {
          id: '3',
          name: 'High',
          color: 'red',
          numericValue: 3,
          rounding: true
        }
      ],
      riskFormula: {
        id: '1',
        name: 'Formula 01',
        equation: riskFormulaEquation,
        formulaType: RiskFormulaType.multiPart,
        rounding: false,
        defaultFormula: true,
        formulas: []
      }
    }
  ] as Array<Assessment>,

  surveyDistributionRisks: [
    {
      id: '1',
      name: 'Earthquake',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '97',
            member: {
              id: '1',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '1',
              name: 'Are your facilities near fault lines?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '2',
              name: 'Are your buildings strapped to their foundations?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '3',
              name: 'Are your standing shelves secured to the floor or wall?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '4',
              name: 'Do your employees know where to turn of the gas and water supply?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '5',
              name: 'Have you felt any earthquakes or tremors within the last five years?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '6',
              name: 'What is the impact and probability of a 8.0 earthquake?',
              type: QuestionType.impactProbability,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: {
                    id: '1',
                    name: 'Impact'
                  },
                  factor: {
                    id: '54',
                    name: 'High'
                  }
                },
                {
                  type: {
                    id: '2',
                    name: 'Probability'
                  },
                  factor: {
                    id: '62',
                    name: 'Low'
                  }
                },
                {
                  type: {
                    id: '3',
                    name: 'Awareness'
                  },
                  factor: {
                    id: '73',
                    name: 'Medium'
                  }
                }
              ],
              skip: false,
              comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        },
        {
          isTemplate: false,
          memberData: {
            id: '98',
            member: {
              id: '2',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '1',
              name: 'Are your facilities near fault lines?',
              type: QuestionType.yesNo,
              questionAnswer: null,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 8,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '2',
              name: 'Are your buildings strapped to their foundations?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '3',
              name: 'Are your standing shelves secured to the floor or wall?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '4',
              name: 'Do your employees know where to turn of the gas and water supply?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '5',
              name: 'Have you felt any earthquakes or tremors within the last five years?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '6',
              name: 'What is the impact and probability of a 8.0 earthquake?',
              type: QuestionType.impactProbability,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: {
                    id: '1',
                    name: 'Impact'
                  },
                  factor: {
                    id: '54',
                    name: 'High'
                  }
                },
                {
                  type: {
                    id: '2',
                    name: 'Probability'
                  },
                  factor: {
                    id: '61',
                    name: 'Low'
                  }
                },
                {
                  type: {
                    id: '3',
                    name: 'Awareness'
                  },
                  factor: {
                    id: '73',
                    name: 'Medium'
                  }
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        },
        {
          isTemplate: false,
          memberData: {
            id: '99',
            member: {
              id: '3',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '1',
              name: 'Are your facilities near fault lines?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '2',
              name: 'Are your buildings strapped to their foundations?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '3',
              name: 'Are your standing shelves secured to the floor or wall?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '4',
              name: 'Do your employees know where to turn of the gas and water supply?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '5',
              name: 'Have you felt any earthquakes or tremors within the last five years?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '6',
              name: 'What is the impact and probability of a 8.0 earthquake?',
              type: QuestionType.impactProbability,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: {
                    id: '1',
                    name: 'Impact'
                  },
                  factor: {
                    id: '54',
                    name: 'High'
                  }
                },
                {
                  type: {
                    id: '2',
                    name: 'Probability'
                  },
                  factor: {
                    id: '61',
                    name: 'Low'
                  }
                },
                {
                  type: {
                    id: '3',
                    name: 'Awareness'
                  },
                  factor: {
                    id: '73',
                    name: 'Medium'
                  }
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        },
        {
          isTemplate: false,
          memberData: {
            id: '100',
            member: {
              id: '4',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '1',
              name: 'Are your facilities near fault lines?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '2',
              name: 'Are your buildings strapped to their foundations?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '3',
              name: 'Are your standing shelves secured to the floor or wall?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '4',
              name: 'Do your employees know where to turn of the gas and water supply?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '5',
              name: 'Have you felt any earthquakes or tremors within the last five years?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '6',
              name: 'What is the impact and probability of a 8.0 earthquake?',
              type: QuestionType.impactProbability,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: {
                    id: '1',
                    name: 'Impact'
                  },
                  factor: {
                    id: '54',
                    name: 'High'
                  }
                },
                {
                  type: {
                    id: '2',
                    name: 'Probability'
                  },
                  factor: {
                    id: '61',
                    name: 'Low'
                  }
                },
                {
                  type: {
                    id: '3',
                    name: 'Awareness'
                  },
                  factor: {
                    id: '73',
                    name: 'Medium'
                  }
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ] as Array<AssessmentMemberData>
    },
    {
      id: '2',
      name: 'Flood',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '2',
            member: {
              id: '1',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '6',
              name: 'Are your facilities in a 100-year flood plain?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '7',
              name: 'Do you have a supply of sand nearby to bag for barriers?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '8',
              name: 'Are your data centers elevated from the ground by 1 foot?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '9',
              name: 'Are your data centers elevated from the ground by 1 foot?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '10',
              name: 'Do you have an offsite data center on the ready?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ] as Array<AssessmentMemberData>
    },
    {
      id: '3',
      name: 'Fire',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '3',
            member: {
              id: '1',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '11',
              name: 'Do you have a 30 foot buffer around your facility free from natural vegetation?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '12',
              name: 'Do you have a fire hydrant located within 100 feet of your facility?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '13',
              name: 'Do you have a fire sprinkler system installed throughout the office?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ] as Array<AssessmentMemberData>
    },
    {
      id: '4',
      name: 'Bomb Threat',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '1',
            member: {
              id: '4',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '14',
              name: 'Do you allow visitors carry personal bags onto your premise?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '15',
              name: 'Do you have trained service animals who can identify suspicous packages?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '16',
              name: 'Do you have contact info on the ready for local government law enforcement agencies?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            },
            {
              id: '17',
              name: 'Do you have procedures for how to answer a call from an anonymous bomb threat?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ] as Array<AssessmentMemberData>
    },
    {
      id: '5',
      name: 'Gas Leak',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '5',
            member: {
              id: '1',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '18',
              name: 'Do you have a designated gathering spot away from the building?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ]
    },
    {
      id: '6',
      name: 'Civic Unrest',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '6',
            member: {
              id: '1',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '19',
              name: 'Do you have have armed security?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ]
    },
    {
      id: '7',
      name: 'Power Outage',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '7',
            member: {
              id: '1',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '20',
              name: 'Do you have a generator?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ]
    },
    {
      id: '8',
      name: '',
      assessmentId: '1',
      rank: 1,
      impact: 1,
      probability: 1,
      requiresPlan: true,
      riskAssessmentMembersData: [
        {
          isTemplate: false,
          memberData: {
            id: '8',
            member: {
              id: '1',
              firstName: '',
              middleInitials: '',
              lastName: '',
              isNotifiable: true,
              name: '',
              displayName: ''
            },
            deletedPersonnelRecord: null,
            totalAnswered: '',
            riskCompleted: false
          },
          memberAnswers: [
            {
              id: '21',
              name: 'Do you employee through temporary agencies?',
              type: QuestionType.yesNo,
              questionAnswer: QuestionAnswer.yes,
              position: 1,
              requireCommentForNA: false,
              rank: 1,
              impact: 1,
              probability: 1,
              impactWeight: 1,
              probabilityWeight: 1,
              factors: [
                {
                  type: null,
                  factor: null
                }
              ],
              skip: false,
              comments: '',
              parent: {
                id: '1',
                name: '',
                entityType: EntityType.site
              }
            }
          ],
          memberCustomValues: []
        }
      ]
    }
  ] as Array<AssessmentDistributionRisk>,

  riskFactors: [
    {
      id: '1',
      name: 'Impact',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.',
      type: RiskFactorType.impact,
      ranks: [
        {
          id: '51',
          name: 'Extremely Low',
          numericValue: 1,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '52',
          name: 'Low',
          numericValue: 2,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '53',
          name: 'Medium',
          numericValue: 3,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '54',
          name: 'High',
          numericValue: 4,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '55',
          name: 'Extremely High',
          numericValue: 5,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        }
      ]
    },
    {
      id: '2',
      name: 'Probability',
      description: 'Probability',
      type: RiskFactorType.probability,
      ranks: [
        {
          id: '61',
          name: 'Extremely Low',
          numericValue: 1,
          description: 'Low'
        },
        {
          id: '62',
          name: 'Low',
          numericValue: 2,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '63',
          name: 'Medium',
          numericValue: 3,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '64',
          name: 'High',
          numericValue: 4,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '65',
          name: 'Extremely High',
          numericValue: 5,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        }
      ]
    },
    {
      id: '3',
      name: 'Awareness',
      description: 'Awareness',
      type: RiskFactorType.probability,
      ranks: [
        {
          id: '71',
          name: 'Extremely Low',
          numericValue: 1,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '72',
          name: 'Low',
          numericValue: 2,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '73',
          name: 'Medium',
          numericValue: 3,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '74',
          name: 'High',
          numericValue: 4,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        },
        {
          id: '75',
          name: 'Extremely High',
          numericValue: 5,
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam vitae bibendum augue. Aliquam fringilla, massa vitae feugiat imperdiet, ante lacus laoreet enim, a interdum mi arcu at elit. Suspendisse et sollicitudin massa, nec scelerisque ante.'
        }
      ]
    }
  ] as Array<RiskFactor>,

  threatQuestions:
    [
      {
        id: '1',
        name: 'Has your company ever experienced a bomb threat?',
        threatId: '1',
        weight: 25,
        type: QuestionType.yesNo,
        evenWeight: false,
        position: 1,
        factorType: QuestionFactorType.impact,
        requireCommentForNA: false,
        increasingAnswer: QuestionAnswer.yes,
        isDefaultQuestion: true
      },
      {
        id: '2',
        name: 'Do you have bomb threat procedures?',
        threatId: '1',
        weight: 25,
        type: QuestionType.yesNo,
        evenWeight: false,
        position: 2,
        factorType: QuestionFactorType.probability,
        requireCommentForNA: true,
        increasingAnswer: QuestionAnswer.no,
        isDefaultQuestion: false
      },
      {
        id: '3',
        name: 'Are all employees aware of your bomb threat procedures?',
        threatId: '1',
        weight: 25,
        type: QuestionType.yesNo,
        evenWeight: false,
        position: 3,
        factorType: QuestionFactorType.impact,
        requireCommentForNA: false,
        increasingAnswer: QuestionAnswer.na,
        isDefaultQuestion: false
      },
      {
        id: '4',
        name: 'What is the impact and probability of bombings?',
        threatId: '1',
        weight: 25,
        type: QuestionType.impactProbability,
        evenWeight: false,
        position: 4,
        factorType: QuestionFactorType.both,
        requireCommentForNA: false,
        increasingAnswer: QuestionAnswer.na,
        isDefaultQuestion: false
      }
    ] as Array<Question>,
  threat: {
    id: '1',
    name: 'threat 1',
    description: '',
    riskTemplate: {
      id: '1',
      name: 'Risk Template 01',
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    },
    threatType: {
      id: '1',
      name: 'Terrorism',
      numericValue: 0,
      lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
      lastUpdatedBy: 'Lastname, Firstname'
    },
    questions: [],
    isPlanRequired: false,
    lastUpdateDate: new Date('2022-01-31T19:52:43.511Z'),
    lastUpdatedBy: 'Lastname, Firstname'
  } as Threat
};

